interface FieldProps {
  /** Tiny uppercase label rendered above the value. */
  l: string;
  /** Value string (already-formatted). */
  v: string;
  /** Color token for the value. Accepts `fg-mute` etc. */
  tone?: string;
}

/** Labeled mini-cell used in the hack modal's intel grid. */
export function Field(props: FieldProps) {
  return (
    <div
      style={{
        background: 'var(--sf-input)',
        border: '1px solid var(--line)',
        padding: '5px 7px',
      }}
    >
      <div class="t-micro" style={{ 'margin-bottom': '1px' }}>{props.l}</div>
      <div
        style={{
          'font-family': 'var(--mono)',
          'font-size': '10.5px',
          color: `var(--${props.tone ?? 'fg'})`,
          'letter-spacing': '0.02em',
        }}
      >
        {props.v}
      </div>
    </div>
  );
}
